import columns from '../../../../../react-table/helpers/columns';

export const textConditionalProps = (state, rowInfo) => {
  const className =
    rowInfo &&
    rowInfo.row.paperfree &&
    rowInfo.row.paperfree === 'N' ? 'text-red' : 'text-green';
  return { className };
};

export const bgConditionalProps = (state, rowInfo) => {
  let className =
    rowInfo &&
    rowInfo.row.paperfree &&
    rowInfo.row.paperfree === 'N' ? 'bg-red' : 'bg-green';
  className += ' text-white';
  return { className };
};

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin operator', 'originOperator').withGetProps(textConditionalProps),
        new TextColumn('Destination operator', 'destinationOperator').withGetProps(textConditionalProps),
        new TextColumn('Carrier', 'carrier').withGetProps(textConditionalProps),
        new TextColumn('Departure', 'departureLocation').withGetProps(textConditionalProps),
        new TextColumn('Arrival', 'arrivalLocation').withGetProps(textConditionalProps),
        new TextColumn('Origin IMPC', 'originImpc').withGetProps(textConditionalProps),
        new TextColumn('Destination IMPC', 'destinationImpc').withGetProps(textConditionalProps),
        new NonZeroNumberColumn('Volume', 'volume').withGetProps(textConditionalProps),
        new TextColumn('Paper free', 'paperfree').withGetProps(bgConditionalProps),
      ],
    },
  ];
};
